// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"3392a6d7a160f4d71c1d","655":"6b643f463affbb838a8b"}[chunkId] + ".js";
};